import { SxProps } from "@mui/material";

export const loaderContainer: SxProps = {
  display: "flex",
  justifyContent: "center",
  width: { md: "100%", xs: "100%" },
  padding: { md: 2 },
  paddingRight: { xs: 0.1 },
};
